<template>
  <component :is="isFotocasa ? 'FotocasaMain' : 'MoleContainer'" :color="color">
    <div class="appointment">
      <h1 :class="isFotocasa ? 'fotocasa__title' : 'appointment__title'">¡Genial!</h1>
      <section class="appointment__datetime">
        <p>Tienes una cita con Trioteca, te llamaremos el próximo:</p>
        <div class="datetime__container">
          <p class="appointment__date">{{ formattedDate }}</p>
          <p class="appointment__time">{{ time }} h</p>
        </div>
      </section>
      <section class="appointment__customer-service">
        <p class="appointment__text">Serás atendido por:</p>
        <div class="customer-service__container">
          <div class="customer-service__info">
            <p class="customer-service__name">{{ customerService.name }}</p>
            <a :href="isFotocasa ? 'mailto:fotocasa@trioteca.com' : 'mailto:tuhipoteca@trioteca.com'" class="customer-service__email"
              ><i class="customer-service__icon"></i>{{ isFotocasa ? 'fotocasa@trioteca.com' : 'tuhipoteca@trioteca.com' }}</a
            >
            <a :href="'tel:+34' + (isFotocasa ? '919037888' : '910054391')" class="customer-service__phone"
              ><i class="customer-service__icon"></i>{{ isFotocasa ? '919 03 78 88' : '910 054 391' }}</a
            >
          </div>
        </div>
      </section>
      <Reviews :score="score" class="mt-xxs" />
      <div v-if="isFunnelExperiment_v2_1 || notFunnel" class="disclaimer disclaimer--success">
        <span><div class="disclaimer__icon"></div></span>
        <p class="disclaimer__text">
          En breve, recibirás la confirmación de la cita al email que nos has dado.
        </p>
      </div>
      <div v-else class="disclaimer disclaimer--warning">
        <span><div class="disclaimer__icon"></div></span>
        <p class="disclaimer__text">
          Hemos enviado un correo a tu bandeja de entrada con información de los próximos pasos.
        </p>
      </div>
      <div class="btn-container">
        <a class="btn btn-primary btn-lg" href="/">Volver a la home</a>
      </div>
    </div>
  </component>
</template>

<script>
import experiments from '@/funnels/mixins/experiments';
import MoleContainer from '@/funnels/components/mole-container/MoleContainer';
import FotocasaMain from '@/funnels/components/layout/fotocasa/Main';
import Reviews from '@/funnels/components/reviews/Reviews';

export default {
  components: { MoleContainer, FotocasaMain, Reviews },
  mixins: [experiments],
  props: {
    datetime: {
      type: String,
      required: true,
    },
    customerService: {
      type: Object,
      required: true,
    },
    score: {
      type: Number,
      default: 5,
    },
    notFunnel: {
      type: Boolean,
      default: false,
    },
    isFotocasa: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      color: 'moles--success',
    };
  },
  computed: {
    icon() {
      return this.customerService.image ?? '/img/fotocasa-hipotecas/icons/att.svg';
    },
    imageAlt() {
      return `Avatar de ${this.customerService.name}.`;
    },
    time() {
      const date = new Date(this.datetime);
      const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
      return date.getHours() + ':' + minutes;
    },
    formattedDate() {
      var date = new Date(this.datetime);
      var month = date.toLocaleDateString('es-ES', { month: 'long' });
      var weekday = date.toLocaleDateString('es-ES', { weekday: 'long' });
      var dayNumber = date.toLocaleDateString('es-Es', { day: 'numeric' });
      return weekday + ' ' + dayNumber + ', ' + month;
    },
  },
};
</script>
